import React from 'react';

import { ModalContext } from '@components/common/Modal/Modal';

export const useModal = () => {
	const context = React.useContext(ModalContext);

	if (context === undefined) {
		throw new Error('useModal must be used within a Modal');
	}

	return context;
};
